export default {
  defaultLocale: "en-US", // 'he-IL'
  availableLocales: ["en-US"], // 'he-IL'
};
